import { MnoConfig } from '../types';

export const mtnNigeriaConfig: MnoConfig = {
  id: 'mtn_ng',
  name: 'MTN Nigeria',
  colors: {
    primary: '#0A69AE',  // Life blue
    secondary: '#FDCD01', // MTN Yellow (operator color)
  },
  countryCode: '234',
  phoneNumberMask: '000 000 0000', // Nigerian phone format (10 digits)
  appUrl: 'https://mtn.ng.life.fun',
  locations: [
    "Abuja",
    "Abia",
    "Adamawa",
    "Akwa Ibom",
    "Anambra",
    "Bauchi",
    "Bayelsa",
    "Benue",
    "Borno",
    "Cross River",
    "Delta",
    "Ebonyi",
    "Edo",
    "Ekiti",
    "Enugu",
    "Gombe",
    "Imo",
    "Jigawa",
    "Kaduna",
    "Kano",
    "Katsina",
    "Kebbi",
    "Kogi",
    "Kwara",
    "Lagos",
    "Nasarawa",
    "Niger",
    "Ogun",
    "Ondo",
    "Osun",
    "Oyo",
    "Plateau",
    "Rivers",
    "Sokoto",
    "Taraba",
    "Yobe",
    "Zamfara",
  ],
};

